// For specific documentation on the Sanitize.js library, config, or transformers, see: https://github.com/gbirke/Sanitize.js
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'sani... Remove this comment to see the full error message
import Sanitize from 'sanitize';

// createHTMLDocument MUST be passed a title or else sanitized content will break in Internet Explorer: https://issues.hubspotcentral.com/browse/CRM-17134
export const secureDocument = document.implementation.createHTMLDocument('sanitize');
export const ALLOWED_ELEMENTS = ['a', 'b', 'blockquote', 'br', 'caption', 'cite', 'code', 'dd', 'dl', 'dt', 'em', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'i', 'li', 'ol', 'p', 'pre', 'q', 'small', 'strike', 'strong', 'sub', 'sup', 'u', 'ul', 'div', 'span', 's', 'table', 'td', 'tbody', 'th', 'thead', 'tr', 'citation-placeholder', 'inline-citation'];

/**
 * Determines if a URL is an internal HubSpot domain that should navigate in the parent window.
 *
 * @param href - The URL string to check
 * @param portalId - The current user's portal ID
 * @returns true if the URL is internal to the authenticated HubSpot experience
 * (hubspot.com, hubspotqa.com, or relative URLs), false otherwise
 *
 * @example
 * isInternalHubSpotDomain('/settings', 12345) // true - relative URL
 * isInternalHubSpotDomain('https://app.hubspot.com/12345/contacts', 12345) // true - HubSpot domain with matching portal
 * isInternalHubSpotDomain('https://google.com', 12345) // false - external domain
 */
export const isInternalHubSpotDomain = (href, portalId) => {
  if (!href) return false;
  if (href.startsWith('/') || href.startsWith('#') || href.startsWith('?')) {
    return true;
  }
  try {
    const url = new URL(href);
    const hostname = url.hostname.toLowerCase();
    return (hostname.endsWith('.hubspot.com') || hostname === 'hubspot.com' || hostname.endsWith('.hubspotqa.com') || hostname === 'hubspotqa.com') && !!portalId && url.pathname.includes(`/${portalId}`);
  } catch (e) {
    // Invalid URL - treat as external for safety
    return false;
  }
};
export const fixInternalLinkTargets = (html, portalId) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const anchors = doc.querySelectorAll('a[href]');
  anchors.forEach(anchor => {
    const href = anchor.getAttribute('href');
    if (href && isInternalHubSpotDomain(href, portalId)) {
      anchor.setAttribute('target', '_top');
    }
  });

  // Safe to use innerHTML here because:
  // 1. Input HTML was already sanitized by Sanitize.js
  // 2. We're only reading from a DOMParser-created document
  // 3. No user input is being written via innerHTML
  return doc.body.innerHTML;
};
export const LlmSanitizerConfig = {
  elements: ALLOWED_ELEMENTS,
  dom: secureDocument,
  attributes: {
    __ALL__: ['style', 'align', 'valign', 'color', 'width', 'height'],
    a: ['href', 'title', 'target'],
    blockquote: ['cite'],
    div: ['dir'],
    ol: ['start', 'type'],
    q: ['cite'],
    span: ['data-at-mention', 'data-owner-id', 'data-mention-id', 'data-mention-name', 'contenteditable', 'data-email-reply', 'data-timestamp', 'data-value', 'data-ai-section-id', 'data-dynamic-section-index', 'data-crm-record-chip', 'data-object-type-id', 'data-object-id', 'data-display-name', 'data-entity-link', 'data-entity-type', 'data-resource-id', 'data-display-text'],
    ul: ['type'],
    'citation-placeholder': ['data-citation-index', 'data-display-number', 'data-index', 'data-citation-type'],
    'inline-citation': ['data-citation-index', 'data-index', 'data-display-number', 'data-citation-type']
  },
  add_attributes: {
    a: {
      rel: 'nofollow noopener noreferrer',
      target: '_blank'
    }
  },
  protocols: {
    a: {
      href: ['ftp', 'http', 'https', 'mailto', 'tel', 'mms', 'sms', Sanitize.RELATIVE]
    },
    blockquote: {
      cite: ['http', 'https', Sanitize.RELATIVE]
    },
    q: {
      cite: ['http', 'https', Sanitize.RELATIVE]
    }
  }
};